var map = {
	"./angry_with_horns.png": 24798,
	"./avocado.png": 5728,
	"./banana.png": 70648,
	"./banjo.png": 75125,
	"./beer_mug.png": 52277,
	"./blessed.png": 81225,
	"./call_me.png": 90110,
	"./cherry.png": 5628,
	"./clap.png": 25305,
	"./claps.png": 39718,
	"./cold_face.png": 84049,
	"./collision.png": 20195,
	"./confetti.png": 29083,
	"./cookies.png": 27230,
	"./cowboy_face.png": 65844,
	"./crossed.png": 82384,
	"./crying_face.png": 22159,
	"./data.csv": 89235,
	"./desert_island.png": 84454,
	"./dizzy.png": 24821,
	"./dollar_struck.png": 2610,
	"./dynamite.png": 92346,
	"./exploding_face.png": 41029,
	"./fries.png": 37106,
	"./ghost_face.png": 64120,
	"./giving_left.png": 2105,
	"./giving_right.png": 72450,
	"./grape.png": 22170,
	"./grapes.png": 31835,
	"./grinning.png": 86155,
	"./hand.png": 6424,
	"./hand_holding_pencil_left.png": 82284,
	"./hand_holding_pencil_right.png": 62345,
	"./heart_eyes.png": 29014,
	"./heart_on_fire.png": 8692,
	"./high_voltage.png": 95528,
	"./horns.png": 10241,
	"./huffing_with_anger.png": 39697,
	"./hugging.png": 99482,
	"./ice_cream.png": 50049,
	"./kissing.png": 85125,
	"./laughing.png": 37006,
	"./leaf_fluttering_in_wind.png": 17625,
	"./love.png": 54123,
	"./meat_bone.png": 15501,
	"./middle_finger.png": 8382,
	"./musical_notes.png": 96771,
	"./nerd.png": 34114,
	"./ok.png": 84285,
	"./ok_right.png": 24754,
	"./oncoming_fist.png": 40788,
	"./open_hands.png": 83792,
	"./partying.png": 79431,
	"./pile_of_poo.png": 47092,
	"./pinch.png": 18191,
	"./pinching_left.png": 23855,
	"./pinching_right.png": 23616,
	"./point_up.png": 43177,
	"./point_up_face.png": 26373,
	"./pointing_down.png": 4418,
	"./pointing_left.png": 54577,
	"./pointing_right.png": 97530,
	"./pointing_right_2.png": 54357,
	"./pointing_up.png": 68653,
	"./poke.png": 70415,
	"./pouting.png": 19183,
	"./pray.png": 24143,
	"./punch_left.png": 45251,
	"./punch_right.png": 72972,
	"./rainbow.png": 36341,
	"./raised_fist.png": 76778,
	"./raising_hands.png": 15709,
	"./robot.png": 53235,
	"./rolling_eyes.png": 30319,
	"./rose.png": 23622,
	"./sad.png": 51967,
	"./saxophone.png": 37262,
	"./sign_of_the_horns.png": 26169,
	"./skull.png": 28384,
	"./sleeping.png": 55700,
	"./smile.png": 39967,
	"./smiling_with_hearts.png": 53883,
	"./smiling_with_horns.png": 10184,
	"./sparkles.png": 47426,
	"./speaker_high_volume.png": 95696,
	"./squinting.png": 83755,
	"./star_struck.png": 8004,
	"./strawberry.png": 48016,
	"./sunglasses.png": 43685,
	"./sunglasses_face.png": 67553,
	"./swearing.png": 24657,
	"./thinking.png": 99467,
	"./thumbs_down.png": 725,
	"./thumbs_up.png": 43102,
	"./tin.png": 70218,
	"./unicorn.png": 62467,
	"./victory.png": 93913,
	"./violin.png": 39972,
	"./vomiting_face.png": 61030,
	"./vulcan_salute.png": 39971,
	"./watermelon.png": 40509,
	"./wave.png": 70528,
	"./winking.png": 46424,
	"./winking_2.png": 44027,
	"./with_monocle.png": 53347,
	"./zany_face.png": 25527
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97107;